import { i18n } from "simplydo/core/i18n";
import {
  getImageUrl,
  groupCoverImage,
  ideaCoverImage,
  userAvatarUrl,
} from "simplydo/core/images";
import { DefaultCapabilities } from "simplydo/react/richtext/editor/extensions/default";
import type { EditorCapabilities } from "simplydo/react/richtext/editor/types";

const SimplePreset: EditorCapabilities = {
  ...DefaultCapabilities,
  bulletList: true,
  orderedList: true,
  bold: true,
  strike: true,
  italic: true,
  underline: true,
  alignment: true,
  mentions: [
    {
      name: "users",
      char: "@",
      formatMention: (user) => ({
        href: `/users/${user._id}`,
        id: user._id,
        label: user?.profile?.fullName,
        description:
          user?.profile?.department || user?.profile?.jobTitle || "User",
        image: userAvatarUrl(user),
      }),
    },
    {
      name: "ideas",
      char: "$",
      formatMention: (idea) => ({
        href: `/ideas/${idea._id}`,
        id: idea._id,
        label: idea?.name,
        description: i18n.t("common:capitalise", { key: "generic.idea" }),
        image: ideaCoverImage(idea),
      }),
    },
    {
      name: "challenges",
      char: "$",
      formatMention: (challenge) => ({
        href: `/challenges/${challenge._id}`,
        id: challenge._id,
        label: challenge?.name,
        description: i18n.t("common:capitalise", { key: "generic.challenge" }),
        image:
          getImageUrl(challenge, ["coverImage", "bannerImage"], ["200x200"]) ??
          "",
      }),
    },
    {
      name: "groups",
      char: "$",
      formatMention: (group) => ({
        href: `/groups/${group._id}`,
        id: group._id,
        label: group?.name,
        description: i18n.t("common:capitalise", { key: "generic.group" }),
        image: groupCoverImage(group),
      }),
    },
  ],
  emoji: true,
  table: true,
  link: { autoLink: true },
  image: { uploadFile: () => Promise.reject() },
  video: {},
  iframe: true,
  file: {
    onClick: (src: string | null) => {
      if (src) {
        window.open(src, "_blank");
      }
    },
    uploadFile: () => Promise.reject(),
  },
};

export default SimplePreset;
